import { useState } from "react";
import LoginForm from "../components/Authentication/LoginForm";
import SignupForm from "../components/Authentication/SignupForm";

export default function LoginPage() {

    const [activeTab, setActiveTab] = useState("login");

    return <div>
                <div className="loginImage">
                    <div className="loginDiv">
                        <div className="tabs">
                            <button
                                className={activeTab === "login" ? "active" : ""}
                                onClick={() => setActiveTab("login")}
                                >
                                Log in
                            </button> 
                            <button
                                className={activeTab === "signup" ? "active" : ""}
                                onClick={() => setActiveTab("signup")}
                                >
                                Sign up
                            </button>
                        </div>
                        <div className="loginDivBackgroundColor">
                            <div className="tabContent">
                                {activeTab === "login" ? <LoginForm /> : <SignupForm activeTab={activeTab} setActiveTab={setActiveTab} />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>;
}